import {EntityService} from "@/model/service/entity-service"
import {AxiosPromise} from "axios"
import {ParcelShop} from "@/model/entity/parcel-shop/parcel-shop"
import {Filter} from "@/model/dto/filter"
import {Page} from "@/model/dto/page"
import { DatatableSort } from "@/model/dto/datatable-sort"

class ParcelShopService extends EntityService<ParcelShop> implements IParcelShopService {
  constructor() {
    super("parcel_shop", ParcelShop)
  }

  fuzzySearch(input: string, country: string, cod: boolean = false): AxiosPromise<ParcelShop[]> {
    return this.$http.get(this.path + "/fuzzy/" + input + "?country=" + country + "&cod=" + cod)
  }

  getPage(page: number, rows: number, filters: Filter[], sort?: DatatableSort, isCodFilterEnabled?: boolean ):
  AxiosPromise<Page<ParcelShop>> {
    return super.getPage(page, rows, filters, sort, isCodFilterEnabled).then(response => {
      response.data.content.forEach(item => {
        (item.country as any).i18nKey = "entity.country." + item.country.isoCodeAlpha2
      })
      return response
    })
  }
}

export interface IParcelShopService extends EntityService<ParcelShop> {
  fuzzySearch(input: string, country: string, cod: boolean): AxiosPromise<ParcelShop[]>
  getPage(page: number, rows: number, filters: Filter[], sort?: DatatableSort, isCodFilterEnabled?: boolean ):
  AxiosPromise<Page<ParcelShop>>
}

const service = new ParcelShopService()

export const parcelShopService = service
